module.exports = __webpack_public_path__ + "img/car.9ecd32e9.jpg";